export const loadPolyfills = async () => {
	if (typeof window !== 'undefined' && !('IntersectionObserver' in window)) {
		await import('./intersection-observer')
	}
	if (typeof window !== 'undefined' && !String.prototype.replaceAll) {
		await import('./replaceAll')
	}
}
